import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getRequest2 } from "./Module";
import { Form, Select as SelectInput } from "antd";
import jMoment from "components/classes/Jmomen";
import uuidv1 from "uuid/v1";
import MaterialIcon from "components/common/MaterialIcon";

@connect(
  (state) => ({
    profile: state.FormBuilder.Common.SelectProfiles.profile,
  }),
  {
    getRequest2,
  }
)
@autobind
/**
 *
 */
export default class SelectProfileInfo extends React.PureComponent {
  static propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string,
    personnelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    profile: PropTypes.object,
    indexProfile: PropTypes.func,
  };

  static defaultProps = {
    inline: true,
    label: undefined,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      profile: {},
      render: true,
      fullName: "",
    };
  }

  /**
   *
   */
  /* componentDidMount() {
    const {indexProfile} = this.props;
    console.log(this.props.personnelId)
    indexProfile(this.props.personnelId, {}, (r) => {
      this.setState({profile:  r && r.data && r.data.meal});
    });
  }*/

  /**
   *
   * @param {Object} np
   */
  /* componentWillReceiveProps(np) {
    if (!app._.isEqual(np.personnelId, this.props.personnelId)) {
      np.indexProfile(np.personnelId, {
      }, (r) => {
        this.setState({profile: r && r.data && r.data.meal});

      });
    }
  }*/
  componentDidMount() {
    const { personnelId } = this.props;

    this.props.getRequest2(personnelId, _, (r) =>
      this.setState({ fullName: r.data })
    );
  }
  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
  }

  /**
   *
   * @return {Object}
   * @private
   */
  _inline() {
    const { inline } = this.props;

    if (inline) {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      };
    }

    return {};
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { personnelId } = this.props;
    const { fullName } = this.state;
    if (!personnelId) {
      return <span>---</span>;
    }
    return (
      <span>
        {fullName} ({personnelId})
      </span>
    );
  }
}
